import isValidCalendarDateString from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Shared/Helpers/isValidCalendarDateString';

type DraftKind = 'number' | 'date';

type FieldValueDraftShape = {
	readonly fieldTypeValue: string;
};

/**
 * Builds the check of one draft kind. The check passes for every other field type and for a blank
 * draft (submitting it clears the field); a number must be finite, a date a real calendar day.
 * Stacked once per kind so each failure carries its own message.
 */
const isFieldValueDraftValid =
	(kind: DraftKind) =>
	<T extends FieldValueDraftShape>(value: unknown, formData: T): boolean => {
		if (formData.fieldTypeValue !== kind || typeof value !== 'string') {
			return true;
		}

		const trimmed = value.trim();

		if (trimmed === '') {
			return true;
		}

		return kind === 'number' ? Number.isFinite(Number(trimmed)) : isValidCalendarDateString(trimmed);
	};

export default isFieldValueDraftValid;
